import { TableState } from './types';
import { put, select } from '@redux-saga/core/effects';
import { selectTable } from '../selectors';
import tableSlice from './slice';
import { TableFriendlyName } from '../info/types';

export function* deleteCustomColumnsData(current: TableFriendlyName): any {
  /* Here we have a hard problem.
    Aggregated data that depends on assignment (num_assignments, pct_completed_assignments...)  may be out-dated at this point for some tables
    Let's do a quick fix: We'll delete all column aggregated data in order to force re-fetch it from DB.
    TODO Improve this solution
    */
  const tableState: TableState = yield select(selectTable);
  for (const value in tableState.customColumnsData) {
    if (value != current) {
      yield put(tableSlice.actions['CUSTOMCOLUMNS:DATA:DELETE']({ friendlyName: value as TableFriendlyName }));
    }
  }
  return;
}
